export const CheckInReasons = {
    ButtonPressed: 'BUTTON_PRESSED',
    CalledResident: 'CALLED_RESIDENT',
    MovementSensorDetected: 'MOVEMENT_SENSOR_DETECTED',
    SeenInPerson: 'SEEN_IN_PERSON',
    TeamMemberVerified: 'TEAM_MEMBER_VERIFIED',
    VerifiedByIntegration: 'VERIFIED_BY_INTEGRATION',
};

export const CheckInStatuses = {
    Unknown: 'UNKNOWN',
    Pending: 'PENDING',
    Complete: 'COMPLETE',
    Expired: 'EXPIRED',
    SkippedOnHold: 'SKIPPED_ON_HOLD',
};

export const CheckInStatusLabels = {
    [CheckInStatuses.Unknown]: 'Unknown',
    [CheckInStatuses.Pending]: 'Not Checked-In',
    [CheckInStatuses.Complete]: 'Checked-In',
    [CheckInStatuses.Expired]: 'Expired',
    [CheckInStatuses.SkippedOnHold]: 'On Hold',
};

export type ValidCheckInStatus = (typeof CheckInStatuses)[keyof typeof CheckInStatuses];

export const CheckInSortOptions = {
    UnitAscending: 'unitAsc',
    UnitDescending: 'unitDesc',
    NameAscending: 'nameAsc',
    NameDescending: 'nameDesc',
} as const;

export type CheckInSortOption = (typeof CheckInSortOptions)[keyof typeof CheckInSortOptions];

export const CheckInSortOptionLabels: Record<CheckInSortOption, string> = {
    [CheckInSortOptions.UnitAscending]: 'Unit Number ↑',
    [CheckInSortOptions.UnitDescending]: 'Unit Number ↓',
    [CheckInSortOptions.NameAscending]: 'Resident Name ↑',
    [CheckInSortOptions.NameDescending]: 'Resident Name ↓',
};

/** Field name alone, for the sort button, which shows direction with an arrow icon. */
export const CheckInSortFieldLabels: Record<CheckInSortOption, string> = {
    [CheckInSortOptions.UnitAscending]: 'Unit Number',
    [CheckInSortOptions.UnitDescending]: 'Unit Number',
    [CheckInSortOptions.NameAscending]: 'Resident Name',
    [CheckInSortOptions.NameDescending]: 'Resident Name',
};

export const isDescendingCheckInSort = (option: CheckInSortOption): boolean =>
    option === CheckInSortOptions.UnitDescending || option === CheckInSortOptions.NameDescending;
